export const ADD_ITEM = 'candidateExperience/entities/candidateProfiles/ADD_ITEM'
export const UPDATE_ITEM = 'candidateExperience/entities/candidateProfiles/UPDATE_ITEM'

export const addItem = (id, item) => ({
  type: ADD_ITEM,
  meta: { id },
  payload: item,
})

export const updateItem = (id, item) => ({
  type: UPDATE_ITEM,
  meta: { id },
  payload: item,
})

const defaultEntity = {}

const entity = (state = defaultEntity, { type, payload }) => {
  switch (type) {
    case ADD_ITEM:
    case UPDATE_ITEM:
      return { ...state, ...payload }

    default:
      return state
  }
}

const defaultMap = {}

const map = (state = defaultMap, { type, meta, payload }) => {
  switch (type) {
    case ADD_ITEM:
    case UPDATE_ITEM:
      return {
        ...state,
        [meta.id]: entity(state[meta.id], { type, payload }),
      }

    default:
      return state
  }
}

export default map

export const getCandidateProfileMap = state => state.entities.candidateProfiles || defaultMap
export const getCandidateProfileEntity = (state, id) => state.entities.candidateProfiles[id] || defaultEntity
